import React, { useState } from "react";
import "./AccountSelector.css";
import { useTranslation } from "react-i18next";
import * as AppUrls from "../../../constants/AppUrls";
import { Redirect } from "react-router-dom";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import i18next from "i18next";
import * as Helpers from "../../../global/Helpers";
import { useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as utils from "../../../global/utils";
import * as Constants from "../../../constants/Constants";
import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";

const AccountSelector = () => {
  const { t } = useTranslation();
  const [redirect, setRedirect] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation();
  const propsDate = location.state || null;
  ;
  var BankAccDetailsList = propsDate?.BankAccDetails || [];
  // var BankAccDetailsList = [
  //   { ACCOUNT_NUMBER: "5654", ACCOUNT_NAME: "account test 1" },
  //   { ACCOUNT_NUMBER: "12345", ACCOUNT_NAME: "account test 2" },
  //   { ACCOUNT_NUMBER: "55555", ACCOUNT_NAME: "account test 3" },
  // ];

  const handleSelect = (accountId) => {
    ;
    setSelectedAccount(accountId);
  };

  const handleOpenNewAccount = () => {
    setSelectedAccount("");
    setIsPopupOpen(true); // Open the popup
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false); // Close the popup
  };

  const handleConfirm = () => {
    ;
    if (selectedAccount === "") {
      Helpers.errorNotify(t("SelectAccountType"), i18next.language);
      return false;
    }
    var result = Helpers.getScreenIdByGroupAndName("Confirm Account");
    var Items = [
      { ID: "280", Value: selectedAccount },
      { ID: "258", Value: "1" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
    ];
    saveKycData(Items, AppUrls.OnboardingNonSIBAccount);
    //setRedirect(AppUrls.OnboardingNonSIBAccount);
  };

  const handleConfirmPopup = () => {
    ;
    if (selectedAccount === "") {
      Helpers.errorNotify(t("SelectAccountType"), i18next.language);
      return false;
    }
    var result = Helpers.getScreenIdByGroupAndName("Confirm Account");
    var Items = [
      { ID: "279", Value: selectedAccount },
      { ID: "258", Value: "1" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
    ];
    saveKycData(Items, AppUrls.OnboardingNonSIBAccount);
    //setRedirect(AppUrls.OnboardingNonSIBAccount);
  };

  const saveKycData = async (Items, RedirectPath) => {
    try {
      const body = {
        RequestItems: Items,
        reqID: localStorage.getItem("RID"),
      };
      var response = utils.CallKYCAPI(Constants.GetKYCCibc, body);
      await response
        .then((response) => {
          ;
          if (response.data.Error_code === "0") {
            setRedirect(RedirectPath);
          } else if (response.data.Error_code === "-1") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.Error_Msg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("saveKycData", error);
        });
    } catch (error) {
      console.error("Error posting data saveKycData:", error);
    }
  };

  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingPersonal);
  };

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <>
      <NavbarOnboarding />

      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} alt="KYC" />
        </div>
        <div className="AccountSelector">
          <div className="CustomerInfo-form">
            <h2 style={{ marginBottom: "2rem" }}>
              {t("pleaseConfirmYourAccount")}
            </h2>
            <div
              style={{
                fontWeight: "500",
                textAlign: "start",
                color: "#0b1d81",
                fontSize: "1rem",
              }}
            >
              {t("UserConfirmsText")}
            </div>
            <div className="mb-3 mt-3 account-selector">
              {BankAccDetailsList.map((obj) => {
                return (
                  <div
                    className={`account-option ${
                      selectedAccount === obj.ACCOUNT_NUMBER ? "selected" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      id="account-1"
                      name="account"
                      value={obj.ACCOUNT_NUMBER}
                      checked={selectedAccount === obj.ACCOUNT_NUMBER}
                      onChange={() => handleSelect(obj.ACCOUNT_NUMBER)}
                    />
                    <label htmlFor="account-1">{obj.ACCOUNT_NAME}</label>
                  </div>
                );
              })}

              {/* <div className={`account-option ${selectedAccount === "1" ? "selected" : ""}`} onClick={() => handleSelect("1")}>
                <input type="radio" id="account-1" name="account" value="1" checked={selectedAccount === "1"} onChange={() => handleSelect("1")} />
                <label htmlFor="account-1">Account - **********************123456</label>
              </div> */}

              {/* <div className={`account-option ${selectedAccount === "2" ? "selected" : ""}`} onClick={() => handleSelect("2")}>
                <input type="radio" id="account-2" name="account" value="2" checked={selectedAccount === "2"} onChange={() => handleSelect("2")} />
                <label htmlFor="account-2">Account - **********************789101</label>
              </div> */}
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  textAlign: "start",
                  fontWeight: "500",
                  color: "#0b1d81",
                  fontSize: "1rem",
                }}
              >
                {t("openNewAccount")}
              </div>
              <button className="openAccount " onClick={handleOpenNewAccount}>
                {t("openAccount")}
              </button>
            </div>

            <button className="submit-button mb-2 mt-2" onClick={handleConfirm}>
              {t("Confirm")}
            </button>
            <div>
              <button className="backBtn" onClick={handleBack}>
                {t("back")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Popup Implementation */}
      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-container-KYC">
            <h2>{t("ChooseAnAccount")}</h2>
            <div className="mb-3 mt-3 account-selector">
              <div
                className={`account-option ${
                  selectedAccount === "6003" ? "selected" : ""
                }`}
                onClick={() => handleSelect("6003")}
              >
                <input
                  type="radio"
                  id="account-6003"
                  name="account"
                  value="6003"
                  checked={selectedAccount === "6003"}
                  onChange={() => handleSelect("6003")}
                />
                <label htmlFor="account-6003">6003 Normal Saving Account</label>
              </div>
              <div
                className={`account-option ${
                  selectedAccount === "1003" ? "selected" : ""
                }`}
                onClick={() => handleSelect("1003")}
              >
                <input
                  type="radio"
                  id="account-1003"
                  name="account"
                  value="1003"
                  checked={selectedAccount === "1003"}
                  onChange={() => handleSelect("1003")}
                />
                <label htmlFor="account-1003">
                  1003 Retail Current Account
                </label>
              </div>
              <div
                className={`account-option ${
                  selectedAccount === "6009" ? "selected" : ""
                }`}
                onClick={() => handleSelect("6009")}
              >
                <input
                  type="radio"
                  id="account-6009"
                  name="account"
                  value="6009"
                  checked={selectedAccount === "6009"}
                  onChange={() => handleSelect("6009")}
                />
                <label htmlFor="account-6009">6009 Digital Account</label>
              </div>
            </div>
            <button className="no-button" onClick={handleClosePopup}>
              {t("cancel")}
            </button>
            <button className="yes-button" onClick={handleConfirmPopup}>
              {t("ok")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountSelector;
